(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("HomeRefinanceCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["HomeRefinanceCalculator"] = factory();
	else
		root["HomeRefinanceCalculator"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition